import React from 'react';

const LoadingSpinner: React.FC = () => (
    <div className="flex justify-center items-center p-8" aria-live="polite" aria-busy="true">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-t-4 border-[#246BFD] border-t-transparent"></div>
        <span className="sr-only">Loading...</span>
    </div>
);

export default LoadingSpinner;